export const formatDate = (value?: string | null) => {
  if (!value || value === '-') return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return match ? `${match[3]}/${match[2]}` : value;
};

export const formatFullDate = (value?: string | null) => {
  if (!value || value === '-') return '-';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : value;
};

export const formatPeriodo = (inicio?: string | null, fim?: string | null) => {
  const start = formatDate(inicio);
  const end = formatDate(fim);
  if (!start || !end) return null;
  return start === end ? start : `${start} a ${end}`;
};
